import { useParams } from "react-router-dom";
import Tab from "../../common/Tab";
import BreadcrumbSearch from "../../common/BreadcrumbSearch";
import NotFound from "../../common/ErrorPage/NotFound";
import MapChart from "./MapChart";
import CandidateSummary from "./CandidateSummary";

const Region = (props) => {
  const { pid, did, rid } = useParams();
  const { tab, fetched, provinces, parties, data } = props;
  const province = provinces.find((p) => p.id === parseInt(pid));

  const district = province && province.districts.find((d) => d.id === did);

  const region = district && district.regions.filter((r) => parseFloat(r.id).toFixed(0) === parseFloat(rid).toFixed(0) && r.rtype === tab);

  if (!region || region.length === 0) {
    return <NotFound />;
  }

  const provinceData = data.provinces.find((pData) => pData.id === province.id);
  const districtData = provinceData && provinceData.districts.find((dData) => dData.id === district.id);

  const regionData = (districtData && districtData.regions.filter((rData) => parseFloat(rData.id).toFixed(0) === parseFloat(rid).toFixed(0) && rData.rtype === tab)) || [{ declared: false, elected: {}, result: [] }];

  // console.log(provinceData, 'provinceData Region component')
  // console.log(districtData, 'districtData Region component')
  // console.log(regionData, 'regionData Region component')
  // console.log(province, 'province')
  // console.log(district, 'district')
  // console.log(region, 'region')
  // console.log(tab, 'tab')
  // console.log(fetched, 'fetched')
  // console.log(provinces, 'provinces')
  // console.log(parties, 'parties')
  // console.log(data, 'data Region component')
  // console.log(pid, 'pid')
  // console.log(did, 'did')
  // console.log(rid, 'rid')
  return (
    <div className="">
      {/* <Tab tab={tab} handleTabChange={props.handleTabChange} /> */}
      <BreadcrumbSearch tab={tab} showSearch={true} searchParam={props.searchParam} provinces={provinces} handleSearch={props.handleSearch} />
      <MapChart pid={pid} did={did} rid={rid} tab={tab} fetched={fetched} provinceColor={province.color} region={region} district={district} />
      <CandidateSummary fetched={fetched} rid={rid} region={region} district={district} provinces={provinces} parties={parties} data={regionData} />
    </div>
  );
};

export default Region;
